import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import { Trans } from "adapters/i18n";
function AnalyticsRequiredWarning({ classes }) {
  return (
    <Typography class={classes.warningAnalytics}>
      <img
        src="../images/ic_warning_outlined.svg"
        alt="icone de alerta"
        class={classes.warningAnalyticsIcon}
      />
      <Trans
        i18nKey="goalPlan:analytics-required-warning-text"
        components={{ b: <b /> }}
      />
    </Typography>
  );
}

const styles = () => {
  return {
    warningAnalyticsIcon: {
      marginRight: "4px",
      marginBottom: "-3px",
      height: "20px",
      color: "red",
    },
    warningAnalytics: {
      margin: "8px",
      fontFamily: "Roboto",
      lineHeight: 1.71,
      color: "#666",
    },
  };
};
export default withStyles(styles)(AnalyticsRequiredWarning);
